/* eslint-disable max-len */
import { React } from 'react'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../../components/Pagination';
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate';
import AnimatedList from '../../../../../components/Animation/AnimatedList';

const Table = ({ voucherList,
    searchParams,
    setSearchParams,
    setPageLoading,
    handleOnClickSort,
    sortValue,
    voucherTotalCount,startDate,endDate,
    voucherCount }) => {
    const navigate = useNavigate()

    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const urlParams = new URLSearchParams(window.location.search);

    const branchUrl = urlParams.get("sort");
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const handleViewVoucher = (voucherId) => {
        navigate(
            `/accounting/voucher-entry/voucher-details/${voucherId}?${searchParams.toString()}`
        );
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    return (
        <div class="-mx-1">
            <div className='text-center absolute w-full'>Voucher Date from <span className="font-semibold">{searchParams?.get('start_date') === null ?  formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ?  formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
            <div class="flex mb-1 overflow-auto pb-[6px] scroll-bar px-1 topHeading" id="search-result">
                <table aria-label="Outside Table" class="w-full " id="admin-table">
                    <thead>
                        <tr>
                            <th id="Voucher Date" class="w-[15%]" onClick={() => { handleSort('transaction_date') }}>
                                <span class="justify-star" >Voucher Date
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "transaction_date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[15%]">
                                <span class="justify-start">Financial Year
                                </span>
                            </th>

                            <th class="w-[15%]">
                                <span class="justify-start">Type
                                </span>
                            </th>
                            <th id="Voucher Number" class="w-[15%]" onClick={() => { handleSort('voucher_number') }}>
                                <span class="justify-start">Voucher #
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "voucher_number" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[15%]">
                                <span class="justify-end">Amount
                                </span>
                            </th>
                            <th class="w-[15%]">
                                <span class="justify-start">Created by
                                </span>
                            </th>
                            <th class="w-[10%]">
                                <span class="justify-center">Action
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>
                    </thead>
                    <tbody>
                        {voucherList?.map((voucher) => (
                            <AnimatedList
                                key={voucher._id}
                                keyItem={voucher._id}
                                title="View Voucher Details"
                                cursorpointer={true}
                                handleClick={(e) => {
                                    if (e.target.classList.contains('prevent-click')) {
                                        return;
                                    }
                                    handleViewVoucher(voucher._id);
                                }}
                                child={
                                    <>
                                        <td className="text-start">{formatAdjustedDate(voucher?.transaction_date) || '-'}</td>
                                        <td className="text-start">{voucher?.financial_year || '-'}</td>
                                        <td className="text-start capitalize">{voucher?.voucher_type || '-'}</td>
                                        <td className="text-start">{voucher?.voucher_number || '-'}</td>
                                        <td className="text-end">{voucher?.total_amount || '-'}</td>
                                        <td className="text-start">{voucher?.created_by || '-'}</td>
                                        <td className="pl-3 pr-6 py-2 text-f2 text-[#031624] cursor-pointer text-start prevent-click">
                                            <div className='flex justify-center items-center'>
                                                <button 
                                                    id='view_grn_details_btn' 
                                                    className='list-actn-btn prevent-click'
                                                    onClick={() => handleViewVoucher(voucher._id)}
                                                >
                                                    View
                                                </button>
                                            </div>
                                        </td>
                                    </>
                                }
                            />
                        ))}
                    </tbody>
                    {voucherCount === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="6" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Vouchers added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            {voucherCount > 10 && <Pagination
                TotalCount={voucherCount}
                totalPageNumber={Math?.ceil(voucherCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>
    )
}
export default Table;   





